import React, { useState } from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import ToolPageLayout from '../../components/ToolPageLayout';
import { useLanguage } from '../../contexts/LanguageContext';

const categorize = (bmi, t) => {
  if (bmi < 18.5) return { label: t('bmi_cat_under'), color: '#F59E0B' };
  if (bmi < 25) return { label: t('bmi_cat_normal'), color: '#10B981' };
  if (bmi < 30) return { label: t('bmi_cat_over'), color: '#F59E0B' };
  return { label: t('bmi_cat_obese'), color: '#EF4444' };
};

const BmiCalculator = () => {
  const { t } = useLanguage();
  const [weight, setWeight] = useState('');
  const [height, setHeight] = useState('');

  const w = parseFloat(weight);
  const hCm = parseFloat(height);
  const hM = hCm > 0 ? hCm / 100 : 0;
  const bmi = w > 0 && hM > 0 ? w / (hM * hM) : null;
  const cat = bmi ? categorize(bmi, t) : null;

  return (
    <ToolPageLayout
      title={t('bmi_title')}
      subtitle={t('bmi_subtitle')}
      specialty="generaliste"
    >
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <Label className="mb-1 block">{t('bmi_weight_label')}</Label>
          <Input
            type="number"
            min="1"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            placeholder={t('bmi_weight_placeholder')}
            className="rounded-xl"
          />
        </div>
        <div>
          <Label className="mb-1 block">{t('bmi_height_label')}</Label>
          <Input
            type="number"
            min="1"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            placeholder={t('bmi_height_placeholder')}
            className="rounded-xl"
          />
        </div>
      </div>

      {bmi && (
        <div className="mt-8 bg-[#F8FAFC] rounded-2xl p-6 text-center border border-[#E2E8F0]">
          <div className="text-sm text-[#64748B] mb-1">{t('bmi_result_label')}</div>
          <div className="text-4xl font-bold text-[#0F172A]">{bmi.toFixed(1)}</div>
          <div className="mt-2 inline-block px-3 py-1 rounded-full text-sm font-semibold" style={{ color: cat.color, backgroundColor: `${cat.color}1A` }}>
            {cat.label}
          </div>
        </div>
      )}

      <div className="mt-8 text-sm text-[#64748B] space-y-1">
        <p>{t('bmi_legend_under')}</p>
        <p>{t('bmi_legend_normal')}</p>
        <p>{t('bmi_legend_over')}</p>
        <p>{t('bmi_legend_obese')}</p>
      </div>
    </ToolPageLayout>
  );
};

export default BmiCalculator;
